import { Deserializer } from 'jsonapi-serializer';
import { CATEGORIES, SUBCATEGORIES, SEC_CATEGORIES,
  SEC_SUBCATEGORIES } from 'constants/apiQueries';
import { parseCompareSectorData } from 'utils/countryProfile';

// Actions
const GET_DATA = 'compare/GET_DATA';
const SET_COUNTRIES = 'compare/SET_COUNTRIES';
const SET_COUNTRY_REPORT = 'compare/SET_COUNTRY_REPORT';
const SET_COUNTRY_REPORT_LOADING = 'compare/SET_COUNTRY_REPORT_LOADING';
const GET_AVERAGES = 'compare/GET_AVERAGES';
const RESET_REPORT_DATA = 'compare/RESET_REPORT_DATA';
const SET_FILTERS = 'compare/SET_FILTERS';

// Reducer
const initialState = {

  data: {},
  countriesReports: {
    1: {},
    2: {},
    3: {}
  },
  countriesReportsLoading: {
    1: false,
    2: false,
    3: false
  },
  filters: {
    years: [],
    countries: []
  },
  averages: {
    composite: {},
    categories: {}
  }
};

// Action Creators
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case RESET_REPORT_DATA:
      return Object.assign({}, state, { countriesReports: { 1: {}, 2: {}, 3: {} }, countriesReportsLoading: { 1: false, 2: false, 3: false } });
    case SET_COUNTRIES:
      return Object.assign({}, state, { countries: action.payload });
    case SET_FILTERS:
      return Object.assign({}, state, { filters: action.payload });
    case GET_DATA: {
      const data = Object.assign({}, state.data, {});
      data[action.payload.iso] = action.payload.data;
      return Object.assign({}, state, { data });
    }
    case GET_AVERAGES:
      return Object.assign({}, state, { averages: action.payload });
    case SET_COUNTRY_REPORT: {
      const countriesReports = { ...state.countriesReports };

      if (action.payload.iso !== '') {
        countriesReports[action.payload.countryNum] = {
          ... action.payload.data,
          iso: action.payload.iso,
          countryNum: action.payload.countryNum
        };
      } else {
        countriesReports[action.payload.countryNum] = action.payload.data;
      }

      return {
        ...state,
        countriesReports
      };
    }
    case SET_COUNTRY_REPORT_LOADING:
      return Object.assign({}, state, { countriesReportsLoading: { ...state.countriesReportsLoading, ...action.payload } });
    default:
      return state;
  }
}

export function setCompareCountries(countries) {
  return {
    type: SET_COUNTRIES,
    payload: countries
  };
}

export function setDataFilters(filters) {
  return {
    type: SET_FILTERS,
    payload: filters
  };
}


export function resetReportData() {
  return {
    type: RESET_REPORT_DATA
  };
}

export function getDataByCountry(iso) {
  const url = `${config.apiHost}/country/${iso}`;
  return dispatch => {
    fetch(url)
      .then(response => response.json())
      .then(data => {
        dispatch({
          type: GET_DATA,
          payload: { iso, data }
        });
      });
  };
}

function getCategoryAverages(dispatch, compositeAverages) {
  const url = `${config.apiHost}/composites`;
  fetch(url)
    .then(response => response.json())
    .then(data => {
      dispatch({
        type: GET_AVERAGES,
        payload: {
          composite: data.data.length ? data.data[0] : {},
          categories: compositeAverages
        }
      });
    });
}

export function getAverages() {
  const url = `${config.apiHost}/categories`;
  return dispatch => {
    fetch(url)
      .then(response => response.json())
      .then(data => {
        getCategoryAverages(dispatch, data.data);
      });
  };
}

export function getCountryProfileReport(iso, countrySector, countryNum, year) {
  return dispatch => {
    if (iso === '') {
      // resets report if country was not selected
      dispatch({
        type: SET_COUNTRY_REPORT,
        payload: {
          iso,
          data: {},
          countryNum

        }
      });
      return;
    }
    const updatedYear = year && Array.isArray(year) ? year.join(',') : null;
    const countrySectorsUrl = `${config.apiHost}/countries?filter[iso]=${iso}${updatedYear ? `&year=${updatedYear}` : ''}&include=country-sectors,country-sectors.sector`;
    dispatch({
      type: SET_COUNTRY_REPORT_LOADING,
      payload: {
        [+countryNum]: true
      }
    });
    fetch(countrySectorsUrl)
      .then(response => response.json())
      .then(data => {
        new Deserializer().deserialize(data, (err, dataParsed) => {
          const sector = dataParsed.length ? dataParsed[0]['country-sectors'].find(s => s.sector.name === countrySector) : {};
          const sections = `${SEC_CATEGORIES},${SEC_SUBCATEGORIES}`;
          const includes = `${CATEGORIES}.${SUBCATEGORIES},${sections}`;
          const sectorDataUrl = `${config.apiHost}/country-sectors/${sector.id}?include=${includes}`;

          fetch(sectorDataUrl)
            .then(response => response.json())
            .then(sectorData => {
              new Deserializer().deserialize(sectorData, (error, sectorDataParsed) => {
                dispatch({
                  type: SET_COUNTRY_REPORT_LOADING,
                  payload: {
                    [+countryNum]: false
                  }
                });
                const sectors = {
                  mining: 'mining',
                  'oil-gas': 'oil & gas'
                };
                const parsedCompareSectorData = parseCompareSectorData(sectorDataParsed, `${dataParsed[0].name} (${sectors[countrySector]})`);
                dispatch({
                  type: SET_COUNTRY_REPORT,
                  payload: {
                    iso,
                    data: { ...parsedCompareSectorData,
                      year: updatedYear,
                      countrySectorName: countrySector
                    },
                    countryNum

                  }
                });
              });
            });
        });
      })
      .catch(() => {
        dispatch({
          type: SET_COUNTRY_REPORT_LOADING,
          payload: {
            [+countryNum]: false
          }
        });
      });
  };
}



// WEBPACK FOOTER //
// ./app/redux-modules/compare.js